import Model from '../../models/model';

const handleChange = ({ formik }) => formik.handleSubmit();
const model = new Model({
	name: 'DahsboardFilter',
	combos: [],
	formGroups: [{
		fields: ['locationId', 'equipmentTypeId', 'connected', 'disconnected'],
		columnSize: 4,
		containerProps: {
			spacing: 4,
			sx: {}
		}
	}],
	columns: [
		{
			field: 'locationId',
			header: 'AllLocation',
			lookup: 'Location',
			inputWrapperProps: {
				xs: 6
			},
			labelContainerProps: {
				sx: {
					'& .MuiTypography-root': {
						color: theme => theme.palette.text.primary,
						fontWeight: 'normal'
					}
				}
			},
			inlineLabel: false,
			onChange: handleChange
		},
		{
			field: 'equipmentTypeId',
			header: 'AllEquipments',
			inputWrapperProps: {
				xs: 6
			},
			labelContainerProps: {
				sx: {
					'& .MuiFormLabel-root:not(.MuiTypography-root)': {
						color: theme => theme.palette.text.primary,
						fontWeight: 'normal'
					}
				}
			},
			inlineLabel: false,
			lookup: 'EquipmentType',
			onChange: handleChange,
			inputWhen: ({ activeRecord }) => !activeRecord.isModalityDashboard
		},
		{
			field: 'connected',
			header: 'Connected',
			type: 'boolean',
			inputWrapperProps: {
				xs: 6
			},

			innerInputWrapperProps: {
				direction: 'row-reverse',
				sx: {
					border: theme => `1px solid ${theme.palette.divider}`,
					borderRadius: theme => theme.spacing(0.5),
					'& .MuiCheckbox-root.Mui-checked': {
						backgroundColor: '#ffffff !important',
						color: '#000 !important'
					},

				},
				alignItems: 'center'
			},
			columnSize: 2,
			labelContainerProps: {
				size: 'auto',
				sx: {
					flex: 1,
					display: 'flex',
					alignItems: 'center',
					'& .MuiFormLabel-root:not(.MuiTypography-root)': {
						color: theme => theme.palette.text.primary,
					}
				}
			},
			inputContainerProps: {
				size: 'auto'
			},
			defaultValue: true,
			onChange: handleChange
		},
		{
			field: 'disconnected',
			header: 'Disconnected',
			type: 'boolean',
			inlineLabelSize: 8,
			inputWrapperProps: {
				xs: 6
			},
			innerInputWrapperProps: {
				direction: 'row-reverse',
				sx: {
					border: theme => `1px solid ${theme.palette.divider}`,
					borderRadius: theme => theme.spacing(0.5),
					'& .MuiCheckbox-root.Mui-checked': {
						backgroundColor: '#ffffff !important',
						color: '#000 !important'
					},

				}
			},
			columnSize: 2,
			labelContainerProps: {
				size: 'auto',
				sx: {
					flex: 1,
					display: 'flex',
					alignItems: 'center',
					'& .MuiFormLabel-root:not(.MuiTypography-root)': {
						color: theme => theme.palette.error.main,
					}
				}
			},
			inputContainerProps: {
				size: 'auto'
			},
			defaultValue: true,
			onChange: handleChange
		}
	]
});

export default model.createFormDialog();
